import * as React from 'react';

import CollectionStar140 from './CollectionStar140';

export const collectionStar140 = () => <CollectionStar140 />;

export default {
    title: 'Illustration|CollectionStar140',
    component: CollectionStar140,
    parameters: {
        notes: "`import CollectionStar140 from 'box-ui-elements/es/illustration/CollectionStar140';`",
    },
};
